<template>
  <span>
    <Dropdown
      split-button
      type="primary"
      @click="handleClick"
      @command="handleCommand"
    >
      下载数据 (Excel)
      <DropdownMenu slot="dropdown">
        <DropdownItem command="showProgress">查看下载处理进度</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <List
      :visible.sync="visible"
      :topic="topic"
    />
  </span>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';

import List from './List';

import Request from '@/core/QuRequest';

const req = new Request();

export default {
  components: {
    Dropdown,
    DropdownMenu,
    DropdownItem,

    List,
  },

  props: {
    topic: {
      type: String,
      required: true,
    },

    args: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  methods: {
    handleClick() {
      this.download();
    },

    handleCommand(command) {
      if (command === 'showProgress') {
        this.visible = true;
      }
    },

    async download() {
      const params = {
        topic: this.topic,
        args: this.args,
      };
      try {
        const data = await req.send(req.Apis.sales.download.requestAdd, params);
        if (data.code === 200) {
          this.$message.success(
            '您提交的下载正在处理，请点击"查看下载处理进度"',
          );
        }
      } catch (err) {
        this.$message.warning(err.message);
      }
    },
  },
};
</script>